import { render } from "./ReadinessDashboard.vue?vue&type=template&id=8f639d60"
import script from "./ReadinessDashboard.vue?vue&type=script&lang=js"
export * from "./ReadinessDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__